import { MediaProviderDto, MediaProviderName } from '../api/sbapi/sbapi-api-model';

export const SPORTRADAR_SCRIPT_LOCALE_ATTRIBUTE = 'data-sr-language';

export const getSportsradarEventIdFromMediaProviders = (mediaProviders?: MediaProviderDto[]) => {
	if (!mediaProviders) {
		return null;
	}

	const sportRadarProviders = mediaProviders.filter(
		mediaProvider => mediaProvider.providerName === MediaProviderName.SPORTRADAR
	);

	const providerEventId = sportRadarProviders.find(provider => provider)?.providerEventId;

	if (!providerEventId) {
		return null;
	}

	return providerEventId;
};

export const getEventSportradarWidgetProviders = (mediaProviders?: MediaProviderDto[]) => {
	if (!mediaProviders) {
		return null;
	}

	return mediaProviders.filter(mediaProvider => mediaProvider.providerName === MediaProviderName.SPORTRADAR);
};

// comeOn iso code
const HINDI_COMEON_ISO = 'in';
const CANADIAN_COMEON_ISO = 'ca';
const FI_GUEST_COMEON_ISO = 'gu';
const DENMARK_COMEON_ISO = 'dk';
const CANADA_ONTARIO_COMEON_ISO = 'on';
const SWEDISH_COMEON_ISO = 'sv';
// supported by Sportradar iso code
const DENMARK_ISO = 'da';
const FINNISH_ISO = 'fi';
const ENGLISH_ISO = 'en';
const SWEDISH_ISO = 'se';

type LocaleMappings = Record<string, string>;
const comeOnToSportradarMappings: LocaleMappings = {
	[HINDI_COMEON_ISO]: ENGLISH_ISO,
	[CANADIAN_COMEON_ISO]: ENGLISH_ISO,
	[FI_GUEST_COMEON_ISO]: FINNISH_ISO,
	[DENMARK_COMEON_ISO]: DENMARK_ISO,
	[CANADA_ONTARIO_COMEON_ISO]: ENGLISH_ISO,
	[SWEDISH_COMEON_ISO]: SWEDISH_ISO
};

export const getSportradarLocale = (isoCode: string) => {
	// India (hindi) is not supported by Sportradar at this time.
	// Canada has the wrong isoCode at the moment
	return comeOnToSportradarMappings[isoCode] || isoCode;
};
